module.exports = __webpack_public_path__ + "img/EconomyTechBackgroundC07_ua.3736a0bc.webp";